export const writeField = (code, value) => {
    let result = '';
    if (value) {
        result += code;
        result += value;
        result += '\r\n';
    }
    return result;
}

export const write = (transactions) => {
    let result;
    if (transactions) {
        result = '\r\n';
        for (let i = 0; i < transactions.length; i++) {
            let transaction = transactions[i];
            result += writeField('D', transaction.date);
            result += writeField('T', transaction.amount);
            result += writeField('T', transaction.revAmount * -1);
            result += writeField('T', -Math.abs(transaction.moneyOut));
            result += writeField('T', Math.abs(transaction.moneyIn));
            // result += writeField('P', transaction.payee);
            result += writeField('N', transaction.ref);
            // result += writeField('L', transaction.category);
            result += writeField('M', transaction.description);
            result += '^\r\n';
        };
    }
    return result;
};


// WEBPACK FOOTER //
// ./src/components/UploadTransactions/qifHelper.js